// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V2H22V22ZM6 18H10V14H6V18ZM14 18H18V14H14V18ZM10 14H14V10H10V14ZM6 6V10H10V6H6ZM14 10H18V6H14V10Z"}}]};

const MosaicFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mosaic-filled',
    ref,
    icon: element,
  },
));

MosaicFilledIcon.displayName = 'MosaicFilledIcon';

export default MosaicFilledIcon;
